import { Tooltip } from 'antd';

import {
  HealthHistoryItem,
  HealthStatus,
} from '../../services/integrationHealthApi';
import { reasonLabel, STATUS_LABEL } from './healthLabels';

// Barrinhas do histórico curto pedido no critério de aceitação. Cor por estado,
// da mais antiga (esquerda) à mais recente (direita) — o backend devolve em
// ordem decrescente, então invertemos para ler no sentido do tempo.
const STATUS_COLOR: Record<HealthStatus, string> = {
  operational: 'var(--success-medium)',
  degraded: 'var(--warning-medium)',
  unavailable: 'var(--error-medium)',
  unknown: 'var(--neutral_light)',
};

function formatTime(value: string): string {
  return new Date(value).toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function HealthHistoryStrip(props: {
  history: HealthHistoryItem[];
  // Sem isto, um card cinza "Sem verificação recente" aparecia com doze
  // tracinhos verdes embaixo — o da direita na posição que a faixa apresenta
  // como "agora". As medições de fato ocorreram, então elas não são
  // reescritas: a faixa inteira é esmaecida para dizer "isto aconteceu, mas
  // não agora".
  stale?: boolean;
}) {
  const { stale } = props;
  const ordered = [...props.history].reverse();

  return (
    <div
      style={{
        display: 'flex',
        gap: 3,
        alignItems: 'center',
        opacity: stale ? 0.35 : 1,
      }}
      title={
        stale ? 'Medições anteriores à interrupção das verificações' : undefined
      }
    >
      {ordered.map((item, index) => (
        <Tooltip
          // sem id estável no histórico; a chave combina instante + posição
          key={`${item.at}-${index}`}
          title={`${formatTime(item.at)} — ${
            STATUS_LABEL[item.status]
          } (${reasonLabel(item.reason)})`}
        >
          <div
            style={{
              width: 8,
              height: 16,
              borderRadius: 2,
              background: STATUS_COLOR[item.status],
            }}
          />
        </Tooltip>
      ))}
    </div>
  );
}
